import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useFetchWithAuth } from '../session/useFetchWithAuth'
import { EventRating, SubmitRatingRequest } from './types'
import { useCurrentUser } from './useCurrentUser'

const URL = import.meta.env.VITE_EPC_API_URL ?? ''

interface SubmitEventRatingParams {
  eventId: string
  ratingData: SubmitRatingRequest
}

export const useSubmitEventRating = () => {
  const fetchWithAuth = useFetchWithAuth()
  const queryClient = useQueryClient()
  const { data: userData } = useCurrentUser()
  const userId = userData?.userId || ''

  return useMutation<EventRating, Error, SubmitEventRatingParams>({
    mutationFn: async ({ eventId, ratingData }) => {
      if (!eventId) {
        throw new Error('Event ID is required to submit rating')
      }

      const response = await fetchWithAuth(`${URL}/events/${eventId}/ratings`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(ratingData),
      })

      return response
    },
    onSuccess: (data, variables) => {
      const { eventId } = variables

      // Invalidate related queries to refresh data
      queryClient.invalidateQueries({ queryKey: ['eventRatings', eventId] })
      queryClient.invalidateQueries({
        queryKey: ['userEventRating', eventId, userId],
      })
      queryClient.invalidateQueries({ queryKey: ['event', eventId] })
    },
  })
}
